import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {PaymentMethods} from '../../models/payment-method.model';

@Injectable({
  providedIn: "root"
})

export class ConfigurationService {
  constructor(private readonly http: HttpClient) {
  }

  fetchPaymentModes(pacNumber: string): Observable<PaymentMethods[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    const params = { pacNumber };
    return this.http.get<PaymentMethods[]>("api/config/payment-mode", { params, headers })
  }
}
